/* Builder B’s typed hooks for WF-15 — the shared transport of src/lib/api.ts
   (`get`), query-key style as there, kept in this folder per the
   Orchestrator’s ruling of 30/08 (lib/api.ts is Orchestrator-only). */
import { useQuery } from '@tanstack/react-query'
import { get } from '@/lib/api'

export interface StatusCell { tone: 'ok' | 'warn' | 'crit'; mark?: string; label: string }

/* WF-15 · internal admin — AD-01…AD-10, static tier */
export interface AdminSurfaces {
  workspacesSearch: string
  workspaces: { name: string; offer: string; locations: string; usage: string; risk: StatusCell }[]
  entitlement: {
    workspace: string
    changePlan: string; changeComped: string; changeWindow: string
    motif: string
    requester: string; secondActor: string; secondActorState: string
  }
  pilot: {
    steps: { n: string; label: string; mark: StatusCell | null }[]
    tiles: { label: string; value: string; hint: string }[]
  }
  disputes: { title: string; meta: string; status: StatusCell }[]
  fraud: { title: string; meta: string; status: StatusCell }[]
  guidance: { destination: string; guide: string; reviewed: string; status: StatusCell }[]
  email: {
    tiles: { label: string; value: string; hint: string }[]
    rows: { title: string; meta: string; action: string }[]
  }
  platform: {
    title: string; strong?: string[]; meta: string
    action?: string; status?: StatusCell; toggle?: boolean
  }[]
  backups: { label: string; value: string; status?: StatusCell }[]
  gates: { title: string; meta: string; mark: StatusCell }[]
}

export const useAdminSurfaces = () =>
  useQuery({ queryKey: ['admin-surfaces'], queryFn: () => get<AdminSurfaces>('/admin/surfaces') })
